import React, { useState } from "react";
import { ArrowLeft, LockKeyhole } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "@/components/boost/Logo";
import { loginMentor } from "@/services/businessService";

export default function MentorLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await loginMentor(email, password);
      navigate("/mentor/dashboard", { replace: true });
    } catch (err) {
      setError(err.message || "Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#04120f] text-white grid place-items-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="flex justify-between items-center mb-8">
          <Link to="/"><Logo /></Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white"><ArrowLeft className="w-4 h-4" /> Back</Link>
        </div>
        <div className="glass-dark rounded-[32px] p-7 sm:p-9 border border-white/10 shadow-emerald-glow">
          <div className="w-12 h-12 rounded-2xl bg-emerald-500/15 text-emerald-300 grid place-items-center"><LockKeyhole className="w-6 h-6" /></div>
          <div className="mt-6 chip-dark">Private Mentor Access</div>
          <h1 className="mt-4 font-display text-4xl font-black">BoostF Business Hub</h1>
          <p className="mt-3 text-white/60">Sign in to manage store performance data.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <label className="block">
              <span className="text-sm text-white/70">Email</span>
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" autoComplete="username" required className="mt-2 w-full rounded-2xl bg-white/5 border border-white/10 px-4 py-3.5 outline-none focus:border-emerald-400" />
            </label>
            <label className="block">
              <span className="text-sm text-white/70">Password</span>
              <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" autoComplete="current-password" required className="mt-2 w-full rounded-2xl bg-white/5 border border-white/10 px-4 py-3.5 outline-none focus:border-emerald-400" />
            </label>
            {error && <div className="rounded-2xl border border-red-400/20 bg-red-400/10 px-4 py-3 text-sm text-red-200">{error}</div>}
            <button disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
